import { render, staticRenderFns } from "./popular_products.vue?vue&type=template&id=d4d89bb0&"
import script from "./popular_products.vue?vue&type=script&lang=js&"
export * from "./popular_products.vue?vue&type=script&lang=js&"
import style0 from "./popular_products.vue?vue&type=style&index=0&id=d4d89bb0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports